import React from 'react';
import dayjs from 'dayjs';

import ContractStaticHeaderItem from '@/components/common/ContractInputHeaderItem/ContractStaticHeaderItem';
import SectionCard from '@/components/common/SectionCard/SectionCard';
import { DEFAULT_DATE_PATTERN } from '@/config/common.config';


interface IContracHeadersProps {
  contract: Contract
}

export default function ContracHeadersPlaceholder({ contract }: IContracHeadersProps) {
  return (
    <SectionCard
      title={{ titleText: 'Contract Header' }}
      collapsable={{ buttonText: 'Contract Header' }}
      padding={true}
    >
      <div className="row">
        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-sm-20">
          <ContractStaticHeaderItem
            label="Customer"
            value={contract?.customer.customerName}
          />
        </div>
        
        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-sm-20">
          <ContractStaticHeaderItem
            label="Ship To Customer"
            value={contract?.shipToCustomer.customerName}
          />
        </div>

        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-sm-20">
          <ContractStaticHeaderItem
            label="Invoice To Customer"
            value={contract?.invoiceToCustomer.customerName}
          />
        </div>

        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-sm-20">
          <ContractStaticHeaderItem
            label="Contract Number"
            value={contract?.contractNumber}
          />
        </div>

        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-sm-20">
          <ContractStaticHeaderItem
            label="Contract Start Date"
            value={
              contract?.contractStartDate
                ? dayjs(contract?.contractStartDate).format(DEFAULT_DATE_PATTERN)
                : null
            }
          />
        </div>

        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-sm-20 mb-xxl-0">
          <ContractStaticHeaderItem
            label="Contract Term (Months)"
            value={contract?.term}
          />
        </div>

        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-sm-20 mb-xxl-0">
          <ContractStaticHeaderItem
            label="Renewable Term"
            value={contract?.renewableTerm}
          />
        </div>

        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <ContractStaticHeaderItem
            label="Currency"
            value={`${contract?.currency.formattedCurrency} (${contract?.currency.currency})`}
          />
        </div>
      </div>
    </SectionCard>
  );
}
